import { StandardRatesHistoryColumns } from "us.collection.admin/components/StandardRates/Constants"

export const COLUMNS = [
  {
    key: StandardRatesHistoryColumns.RATE_ID,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_ID",
    width: "130px",
  },
  {
    key: StandardRatesHistoryColumns.RATE,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.RATE",
    width: "130px",
  },
  {
    key: StandardRatesHistoryColumns.EFFECTIVE_DATE,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.EFFECTIVE_DATE",
    width: "160px",
  },
  {
    key: StandardRatesHistoryColumns.ACTION,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.ACTION",
    width: "130px",
  },
  {
    key: StandardRatesHistoryColumns.MODIFIED_DATE,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.MODIFIED_DATE",
    width: "160px",
  },
  {
    key: StandardRatesHistoryColumns.MODIFIED_BY,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.MODIFIED_BY",
    width: "230px",
  },
  {
    key: StandardRatesHistoryColumns.COMMENT,
    title: "US.COLLECTION.ADMIN:STANDARD_RATE.COMMENT",
  },
];